import { get } from "lodash";
import ApiCalls from "../../../config/paymentConfig/apiCalls";
import Headers from "../../../config/paymentConfig/headers";
import {
  keyMapsAction,
  keyMapsMutation,
} from "../../../helpers/paymentHelpers/storeKeys";
import Utility from "../../../helpers/paymentHelpers/utility";
import {
  RESPONSE,
  common,
} from "../../../helpers/paymentHelpers/paymentConstants";
// import ampUtility from "../../../helpers/paymentHelpers/amplitude/ampUtility";

export default {
  namespaced: true,
  state: {
    addUpiIdAddModalIsOpen: false,
    circleReloadModalIsOpen: false,
    enteredUPiId: "",
    payViaUpiCollectModal: false,
    upiCollectTimer: 600, // in sec
    upiCollectPollTimer: 5, // in sec
    stopCollectPolling: false,
    collectTimeout: null,
  },
  getters: {},
  mutations: {
    updateAddUpiIdModal(state, payload) {
      state.addUpiIdAddModalIsOpen = payload;
      payload && document.body.classList.add("body-stop-scroll-mobile");
    },
    updateCircleReloadModal(state, payload) {
      state.circleReloadModalIsOpen = payload;
      state.stopCollectPolling = !payload;
      if (payload) document.body.classList.add("body-stop-scroll-mobile");
      else {
        document.body.classList.remove("body-stop-scroll-mobile");
        clearTimeout(state.collectTimeout);
      }
    },
    updatePayViaUpiCollectModalBarModal(state, payload) {
      state.payViaUpiCollectModal = payload;
      state.stopCollectPolling = !payload;
      if (payload) document.body.classList.add("body-stop-scroll-mobile");
      else {
        document.body.classList.remove("body-stop-scroll-mobile");
        clearTimeout(state.collectTimeout);
      }
    },
    updateEnteredUPiId(state, payload) {
      state.enteredUPiId = payload;
    },
    updateUPICollectTimer(state, payload) {
      state.upiCollectTimer = payload;
    },
    updateUPICollectPollTimer(state, payload) {
      state.upiCollectPollTimer = payload;
    },
    updateStopCollectPolling(state, payload) {
      state.stopCollectPolling = payload;
    },
  },
  actions: {
    upiWalletPaymentGateway({ commit, state, dispatch, rootState }, payload) {
      if (Utility.checkIfPlatformIsAndroid()) {
        // intent flow
        commit("updateCircleReloadModal", true);
        let upiIntentConfig = {
          showUPIIntent: true,
          upiTransactionError: false,
        };
        commit(
          keyMapsMutation.UPDATE_UPI_INTENT_CONFIG_MUTATION,
          upiIntentConfig,
          { root: true }
        );
        const {
          paytmPayload = {},
          tenderAmount = 0,
          mercUniqRef = "",
          upiIntentPayload = {},
          processTransactionURL = "",
          orderTransactionId = "",
        } = payload || {};
        const { orderId = "", mid = "" } = paytmPayload;
        let paytm_pgPayload = {
          ORDERID: orderId,
          MID: mid,
          TXNAMOUNT: tenderAmount,
          MERC_UNQ_REF: mercUniqRef,
          STATUS: "TXN_MOCK",
        };
        commit(
          keyMapsMutation.UPDATE_PAYLOAD_FOR_PAYTM_PG_MUTATION,
          paytm_pgPayload,
          { root: true }
        );
        dispatch(
          keyMapsAction.GET_PROCESS_TRANSACTION_API_ACTION,
          {
            url: processTransactionURL,
            orderTransactionId: orderTransactionId,
            payload: upiIntentPayload,
            paytm_pgPayload: paytm_pgPayload,
          },
          { root: true }
        );
      } else {
        // collect flow
        // commit("updateAddUpiIdModal", true); // we don't have to open modal here instead of at time of clicking on place order in foot
        let upiCollectConfig = {
          showUPIIntent: false,
          upiTransactionError: false,
        };
        commit(
          keyMapsMutation.UPDATE_UPI_INTENT_CONFIG_MUTATION,
          upiCollectConfig,
          { root: true }
        );
        dispatch("addUpiIdApi", payload || {});
      }
    },
    addUpiIdApi({ commit, state, dispatch }, payload) {
      if (payload) {
        const { paytmPayload = {}, processTransactionURL = "" } = payload || {};
        const { mid = "", orderId = "" } = paytmPayload;
        // let upiId = {payerAccount: state.enteredUPiId} || {}
        let formObj = { ...paytmPayload, payerAccount: state.enteredUPiId };
        // Redirect to a New Page for Adding UPI Id
        if (mid && orderId) {
          dispatch(
            keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
            { action: "Redirect", pAction: "UPI_COLLECT", pg: "PAYTM_PG" },
            { root: true }
          );
          Utility.postFormData(processTransactionURL, formObj);
        } else {
        }
      }
    },
    collectFlowPolling({ commit, state, dispatch, rootState }, data) {
      console.log("UPI COLLECT FLOW POLLING...", data);
      let { payload, upiType } = data;
      if (upiType === "COLLECT") {
        commit("updatePayViaUpiCollectModalBarModal", true);
      } else {
        commit("updateCircleReloadModal", true);
      }
      const unifiedResponse = payload.unifiedPaymentResponse;
      const pollResponse = get(unifiedResponse, "nextActions.poll", {});
      const { duration = 600000, interval = 5000, url } = pollResponse;
      commit("updateUPICollectTimer", Number(duration) / 1000);
      commit("updateUPICollectPollTimer", Number(interval) / 1000);
      //call the polling and timer
      dispatch("collectPollCounter", { tillTime: duration, upiType });
      dispatch("collectUPIStatus", {
        delay: interval,
        url,
        orderTransactionId: payload.orderTransactionId,
        upiType,
      });
    },
    collectPollCounter({ commit, state, dispatch }, payload) {
      let { tillTime, upiType } = payload;
      state.collectTimeout = setTimeout(() => {
        console.log("TIME out...");
        commit("updateStopCollectPolling", true);
        if (upiType === "COLLECT") {
          commit("updatePayViaUpiCollectModalBarModal", false);
        } else {
          commit("updateCircleReloadModal", false);
        }
        //timeout error
        const content = {
          bodyMsg: common.internalServerError || "Timeout Error",
          headerMsg: common.ops,
          rightCTAText: common.ok,
        };
        dispatch(keyMapsAction.OPEN_ERROR_MODAL, content, { root: true });
      }, tillTime);
    },
    collectUPIStatus({ commit, rootState, state, dispatch }, payload) {
      try {
        console.log("GET COLLECT STAUS....", payload, state.stopCollectPolling);
        setTimeout(() => {
          ApiCalls.GET_COLLECT_UPI_STATUS_API({
            headers: Headers(),
            payload: {},
            url: payload.url,
          })
            .then(function (res) {
              if (res?.data) {
                let response = res?.data;
                console.log("RESPONSE....", res);
                switch (response.transactionStatus) {
                  case RESPONSE.INPROGRESS:
                    if (!state.stopCollectPolling) {
                      dispatch("collectUPIStatus", payload);
                    }
                    break;
                  case RESPONSE.SUCCESS: {
                    Utility.sendToThankYouScreen(payload.orderTransactionId);
                    console.log("SUCCESS....", payload);
                    setTimeout(() => {
                      if (payload.upiType === "COLLECT") {
                        commit("updatePayViaUpiCollectModalBarModal", false);
                      } else {
                        commit("updateCircleReloadModal", false);
                      }
                    }, 1000);
                    break;
                  }
                  case RESPONSE.FAILED: {
                    console.log("FAILURE......", response);
                    const errMsg =
                      (response && response.displayMsg) ||
                      common.internalServerError;
                    const data = {
                      bodyMsg: errMsg,
                      headerMsg: common.ops,
                      rightCTAText: common.ok,
                    };
                    dispatch(keyMapsAction.OPEN_ERROR_MODAL, data, {
                      root: true,
                    });
                    if (payload.upiType === "COLLECT") {
                      commit("updatePayViaUpiCollectModalBarModal", false);
                    } else {
                      commit("updateCircleReloadModal", false);
                    }
                    // ampUtility.upiFailureEventAmp({
                    //   eventAction: "PAYMENT_VERIFY_SERVICE_ERROR",
                    //   eventCategory: "UPI Failure",
                    //   eventLabel: ""
                    // });
                    break;
                  }
                  default: {
                    const content = {
                      bodyMsg: common.internalServerError,
                      headerMsg: common.ops,
                      rightCTAText: common.ok,
                    };
                    dispatch(keyMapsAction.OPEN_ERROR_MODAL, content, {
                      root: true,
                    });
                    if (payload.upiType === "COLLECT") {
                      commit("updatePayViaUpiCollectModalBarModal", false);
                    } else {
                      commit("updateCircleReloadModal", false);
                    }
                    // ampUtility.upiFailureEventAmp({
                    //   eventAction: "PAYMENT_VERIFY_SERVICE_ERROR",
                    //   eventCategory: "UPI Failure",
                    //   eventLabel: ""
                    // });
                    break;
                  }
                }
              } else if (res?.errors) {
                const err = get(res, "errors[0]", "");
                const errData = {
                  bodyMsg: err.displayMsg || common.internalServerError,
                  headerMsg: err.header || common.ops,
                  rightCTAText: err.btnMsg || common.ok,
                };
                dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                  root: true,
                });
                if (payload.upiType === "COLLECT") {
                  commit("updatePayViaUpiCollectModalBarModal", false);
                } else {
                  commit("updateCircleReloadModal", false);
                }
                // ampUtility.upiFailureEventAmp({
                //   eventAction: "PAYMENT_VERIFY_SERVICE_ERROR",
                //   eventCategory: "UPI Failure",
                //   eventLabel: ""
                // });
              } else if (res?.error) {
                const errData = {
                  bodyMsg: res.message || common.internalServerError,
                  headerMsg: common.ops,
                  rightCTAText: common.ok,
                };
                dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                  root: true,
                });
                if (payload.upiType === "COLLECT") {
                  commit("updatePayViaUpiCollectModalBarModal", false);
                } else {
                  commit("updateCircleReloadModal", false);
                }
                // ampUtility.upiFailureEventAmp({
                //   eventAction: "PAYMENT_VERIFY_SERVICE_ERROR",
                //   eventCategory: "UPI Failure",
                //   eventLabel: ""
                // });
              }
            })
            .catch(function (error) {
              console.log("ERROR in collect UPI status.... 101", error);
              const err = get(error, "errors[0]", "");
              const errData = {
                bodyMsg: err.displayMsg || "Failed to get status",
                headerMsg: err.header || common.ops,
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
              if (payload.upiType === "COLLECT") {
                commit("updatePayViaUpiCollectModalBarModal", false);
              } else {
                commit("updateCircleReloadModal", false);
              }
            });
        }, payload.delay);
      } catch (err) {
        console.error("ERROR IN collect UPI status", err);
        if (payload.upiType === "COLLECT") {
          commit("updatePayViaUpiCollectModalBarModal", false);
        } else {
          commit("updateCircleReloadModal", false);
        }
      }
    },
  },
};
